import React from 'react'
import { Tooltip, IconButton, Box, useTheme } from '@mui/material'
import EditIcon from '@mui/icons-material/Edit'

interface DescriptionTooltipLabelProps {
  content: string
  onClick: () => void
  isDraft: boolean
}

const DescriptionTooltipLabel: React.FC<DescriptionTooltipLabelProps> = ({ content, onClick, isDraft }) => {
  const theme = useTheme()

  return (
    <>
      {isDraft ? (
        <Tooltip
          title={
            <Box
              dangerouslySetInnerHTML={{ __html: content }}
              style={{
                width: '100%',
                minWidth: '500px',
                display: 'flex',
                flexDirection: 'column',
                color: theme.palette.text.primary,
                fontSize: '0.875rem',
                lineHeight: '1.4em',
              }}
            />
          }
          arrow
          placement="top-end"
          slotProps={{
            tooltip: {
              sx: {
                maxWidth: '600px',
                backgroundColor: 'background.tooltip',
                color: 'text.primary',
                padding: '16px',
                borderRadius: '8px',
                textAlign: 'left',
              },
            },
            arrow: {
              sx: {
                color: 'background.tooltip',
              },
            },
            // popper: {
            //   modifiers: [
            //     {
            //       name: 'offset',
            //       options: {
            //         offset: [0, 10],
            //       },
            //     },
            //   ],
            // },
          }}
        >
          <IconButton onClick={onClick} sx={{ padding: 1.5 }} size="small" disabled={!isDraft}>
            <EditIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      ) : (
        <IconButton onClick={onClick} sx={{ padding: 1.5 }} size="small" disabled={!isDraft}>
          <EditIcon
            fontSize="small"
            sx={{ color: !isDraft ? theme.palette.text.secondary : theme.palette.text.primary }}
          />
        </IconButton>
      )}
    </>
  )
}

export default DescriptionTooltipLabel
